import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getSmartGoalsList = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/goals/smart-goal/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSmartGoal = ({ goalUuid, version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/goals/smart-goal/${goalUuid}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCounts = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/goals/smart-goal/get-counts/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createSmartGoal = ({
  version = 'v1',
  payload,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/goals/smart-goal/`,
      method: RequestMethod.POST,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSmartGoal = ({
  uuid,
  version = 'v1',
  payload,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/goals/smart-goal/${uuid}/`,
      method: RequestMethod.PATCH,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteSmartGoal = ({ uuid, version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/goals/smart-goal/${uuid}/`,
      method: RequestMethod.DELETE,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPredefinedGoals = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/goals/predefined-smart-goals/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
